const URL_PARAMETERS = {
	accessCode: 'access_code',
	country: 'country',
	countryId: 'countryid', // soon to be deprecated (replaced by country)
	currency: 'currency',
	customAttributes: 'customAttributes', // Optional parameters send by partners that need to be returned to webshop
	disableOfferingOptions: 'disableOptions', // Optional parameter send by partners to disable the offering options selection/change
	editColors: 'edit-colors',
	email: 'email',
	externalOfferingId: 'eoid',
	language: 'language',
	locale: 'locale', // soon to be deprecated (replaced by language)
	priceMultiplier: 'pr_mu',
	shopId: 'shopid', // shop id is set by SmartLink when used API key belongs to a record in the shop table
	sizeSelect: 'sizeselect',
	skuQuantity: 'sku_q', // Optional parameter send by partners to prefill the quantity of the SKU
	userToken: 'user_token',
	voucherCode: 'vc',
};

export default URL_PARAMETERS;
